export const actions = {
    GET_UNREAD_ANNOUNCEMENT_COUNT: 'GET_UNREAD_ANNOUNCEMENT_COUNT',
    SET_UNREAD_ANNOUNCEMENT_COUNT: 'SET_UNREAD_ANNOUNCEMENT_COUNT',
    LOGIN_ANNOUNCEMENT_GET: 'LOGIN_ANNOUNCEMENT_GET',
    LOGIN_ANNOUNCEMENT_SET: 'LOGIN_ANNOUNCEMENT_SET',
    GET_ANNOUNCEMENT_LIST: 'GET_ANNOUNCEMENT_LIST',
    SET_ANNOUNCEMENT_LIST: 'SET_ANNOUNCEMENT_LIST',
    GET_SELECTED_ANNOUNCEMENT: 'GET_SELECTED_ANNOUNCEMENT',
    SET_SELECTED_ANNOUNCEMENT: 'SET_SELECTED_ANNOUNCEMENT',
    ADD_ANNOUNCEMENT: 'ADD_ANNOUNCEMENT',
    ADD_ANNOUNCEMENT_SET: 'ADD_ANNOUNCEMENT_SET',
    GET_SELECTED_LOGIN_ANNOUNCEMENT: 'GET_SELECTED_LOGIN_ANNOUNCEMENT',
    SET_SELECTED_LOGIN_ANNOUNCEMENT: 'SET_SELECTED_LOGIN_ANNOUNCEMENT',
    SET_ANNOUNCEMENT_DATA_DEFAULT: 'SET_ANNOUNCEMENT_DATA_DEFAULT',
    GET_ANNOUNCEMENT_DATA: 'GET_ANNOUNCEMENT_DATA',
    SET_ANNOUNCEMENT_DATA: 'SET_ANNOUNCEMENT_DATA',
    GET_DELETE_ANNOUNCEMENT: 'GET_DELETE_ANNOUNCEMENT',
    SET_SELECTED_ANNOUNCEMENT_DATA_DEFAULT: 'SET_SELECTED_ANNOUNCEMENT_DATA_DEFAULT',
    GET_COURSE_ANNOUNCEMENT: 'GET_COURSE_ANNOUNCEMENT',
    GET_READ_ANNOUNCEMENT: 'GET_READ_ANNOUNCEMENT',
    SET_LOGIN_ANNOUNCEMENT_ERROR: 'SET_LOGIN_ANNOUNCEMENT_ERROR'

};
